module.exports = __webpack_public_path__ + "static/media/project8.93d19f80.jpeg";